import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { signInWithGoogle, signOutUser, getUserFromStorage } from '../firebaseService';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Check for user in local storage on component mount
    const storedUser = getUserFromStorage();
    setUser(storedUser);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogin = async () => {
    const result = await signInWithGoogle();
    if (result.success) {
      const storedUser = getUserFromStorage();
      setUser(storedUser);
      setIsMenuOpen(false);
    } else {
      alert('Login failed. Please try again.');
    }
  };

  const handleLogout = async () => {
    const result = await signOutUser();
    if (result.success) {
      setUser(null);
      setIsMenuOpen(false);
      // Redirect to home page after logout
      window.location.href = '/';
    } else {
      alert('Logout failed. Please try again.');
    }
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="nav-brand">
          <img 
            src={`${process.env.PUBLIC_URL}/icon.png`}
            alt="HeyGerman Logo" 
            style={{ 
              width: '32px', 
              height: '32px', 
              marginRight: '10px', 
              verticalAlign: 'middle' 
            }} 
          />
          HeyGerman
        </Link>
        
        <button className="nav-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/')}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about')}`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact')}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact Us
            </Link>
          </li>
          <li className="nav-item">
            {user ? (
              <button 
                onClick={handleLogout}
                style={{ 
                  backgroundColor: '#dc3545',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '1rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 8px rgba(220, 53, 69, 0.3)',
                  display: 'inline-block',
                  textDecoration: 'none'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#c82333';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(220, 53, 69, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#dc3545';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 8px rgba(220, 53, 69, 0.3)';
                }}
              >
                Logout
              </button>
            ) : (
              <button 
                onClick={handleLogin}
                style={{ 
                  backgroundColor: '#667eea',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '1rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                  display: 'inline-block',
                  textDecoration: 'none'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#5a67d8';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#667eea';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.3)';
                }}
              >
                Login
              </button>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;